/** Resolution steps accepted by the streams API. */
export const RESOLUTION_STEPS = [
    { label: "500ms", ms: 500 },
    { label: "1s", ms: 1_000 },
    { label: "5s", ms: 5_000 },
    { label: "15s", ms: 15_000 },
    { label: "30s", ms: 30_000 },
    { label: "1m", ms: 60_000 },
    { label: "5m", ms: 300_000 },
    { label: "1h", ms: 3_600_000 },
] as const;

export type ResolutionLabel = (typeof RESOLUTION_STEPS)[number]["label"];

/**
 * Pick the coarsest resolution step ≥ span/plotWidth so points are not denser than pixels.
 * Prefer a resolution that yields at least 2 points when possible (a line needs ≥2 points).
 * Very short spans may still produce fewer than 2 points at the finest step (500ms).
 */
export function pickResolution(widthPx: number, startMs: number, endMs: number): ResolutionLabel {
    if (endMs <= startMs) return RESOLUTION_STEPS[4].label;

    const span = endMs - startMs;
    const targetStepMs = span / Math.max(1, widthPx);

    let chosenIdx = RESOLUTION_STEPS.length - 1;
    for (let i = 0; i < RESOLUTION_STEPS.length; i++) {
        if (RESOLUTION_STEPS[i].ms >= targetStepMs) {
            chosenIdx = i;
            break;
        }
    }

    while (chosenIdx > 0 && span / RESOLUTION_STEPS[chosenIdx].ms < 2) {
        chosenIdx--;
    }

    return RESOLUTION_STEPS[chosenIdx].label;
}
